export default [
  { id: 1, name: 'Дополнительный офис на Нагатинской' },
  { id: 2, name: 'Дополнительный офис на Варшавском шоссе' },
  { id: 3, name: 'Складской комплекс в г. Подольск' },
  { id: 4, name: 'Дополнительный офис на Коломенской' },
  { id: 5, name: 'Дирекция СФО-ЗАПАД' },
  { id: 6, name: 'Дирекция ПФО-СЕВЕР' },
  { id: 7, name: 'Дирекция ДвФО' },
  { id: 8, name: 'Дирекция ПФО-ЮГ' },
  { id: 9, name: 'Дирекция СЗФО' },
  { id: 10, name: 'Дирекция ЦФО-СЕВЕР' },
  { id: 11, name: 'Дирекция СФО-Восток' },
  { id: 12, name: 'Дирекция УФО' },
  { id: 13, name: 'Дирекция ЦФО-Юг' },
  { id: 14, name: 'Дирекция ЮФО' },
  { id: 15, name: 'Техподдержка' },
];
